module.exports = __webpack_public_path__ + "img/Dragonlab_FlowWatch-white.a8bd8724.svg";